import React, { useState, useEffect} from "react";
import {
  fetchServicesProvider,
  fetchServicesChecklist,
  fetchServicesListItems,
  updateServiceList
} from "../../../store/Practice/Services/ServicesActions";
import { useDispatch, useSelector } from "react-redux";
import CgFormCreator from "../../../common/CgFormCreator";
import PopupModal from "../../../common/PopupModal";
import { useLocation } from "react-router-dom";
import "./services.scss";
import defaultProfileIcon from "../../../assets/images/defaultProfileIcon.svg";

const Services = () => {
  const [openPopup, setOpenPopup] = useState(false);
  const [confirmDeleteMap, setConfirmDeleteMap] = useState({});
  const [serviceList, setServiceList] = useState();
  const [updateProveiderId, setUpdateProveiderId] = useState("");
  const [showError, setShowError] = useState(false);
  const [providerIdCheck, setProviderIdCheck] = useState(false);
  const dispatch = useDispatch();

  const { servicesData, isServicesLoading } = useSelector(
    (state) => state.practiceServicesList
  );
  const { servicesCheckData } = useSelector(
    (state) => state.practiceServicesChecklist
  );
  const { servicesListItemsData, isServicesListItemsLoading, servicelistErrMsg } = useSelector(
    (state) => state.practiceServicesListItems
  );

  const location = useLocation();
  const locationHeaderData = location.pathname.split("/");
  const practiceId = locationHeaderData[2];

  useEffect(() => {
    dispatch(fetchServicesProvider(practiceId));
    dispatch(fetchServicesChecklist());
  }, []);

  useEffect(() => {
    if(servicesData.length > 0 ){
      setUpdateProveiderId(servicesData[0].providerDisplayId);
      dispatch(fetchServicesListItems( {practiceId: practiceId, providerId: servicesData[0].providerDisplayId}));
    }
  }, [servicesData]);

  useEffect(() => {
    if (servicelistErrMsg) {
      setShowError(true);
        setTimeout(() => {
          setShowError(false);
        }, 2000);
    }
  }, [servicelistErrMsg]);

  useEffect(() => {
    if (providerIdCheck) {
      setTimeout(() => {
        setProviderIdCheck(false);
      }, 1000)
    }
  })

  useEffect(()=>{
    if(servicesListItemsData.length > 0){
      setServiceList(servicesListItemsData);
    } else {
      setServiceList([]);
    }
  }, [servicesListItemsData])

  const getCheckBoxDefault = (val) => {
    const defaultVal = [];
    servicesCheckData?.map((item1) => {
      const item2 = val?.find((item) => item.name === item1.name);
      if (item2) {
        defaultVal.push(item1.slug);
      }
    });
    return defaultVal;
  };

  const ServicesSchema = [
    {
      component: "checkbox",
      options: servicesCheckData,
      keyValues: { label: "name", value: "slug" },
      onSelect: () => {},
      defaultValues: getCheckBoxDefault(serviceList),
      name: "ServiceCHeckbox",
      customRenderLabel: () => {
        return (
          <div className="popup-checkbox-subheading">
            <p>Search results are based on your specialty and commonly-performed procedures. 
              Please indicate the procedures below for which you would like to appear in search results.</p>
          </div>
        );
      },
    },
  ];

  const RenderServiceTabContent = () => {
    if (isServicesLoading) return null;
    return (
      <div className="services-list">
        <ul>
          {servicesData?.map((item) => {
            return (
              <>
                <li
                  onClick={() => {
                    tablistGroup(item);
                  }} 
                  key={item.providerDisplayId}
                  className={
                    updateProveiderId === item.providerDisplayId ? "active" : ""
                  }
                >
                  <div className="service-item">
                    <div className="service-image">
                      {item.profileImage.small ? (
                      <img src={item.profileImage.small} alt="profile-image" />):(
                       <img alt="" src={defaultProfileIcon}/>
                      )}
                    </div>
                    <div className="service-price">Dr. {item.firstName.charAt(0)} {item.lastName}</div>
                  </div>
                </li>
              </>
            );
          })}
        </ul>
      </div>
    );
  };

  const toggleConfirmDelete = (displayId, value) => {
    setConfirmDeleteMap((prev) => ({
      ...prev,
      [displayId]: value,
    }));
  };

  const deleteAPiCall = (bundleCategoryId) => {
      const updateList = [];
      serviceList?.map((item) => {
        if(item.bundleCategoryId !== bundleCategoryId){
          updateList.push(item.slug);
        }})
      
      dispatch(updateServiceList({practiceId: practiceId, data:{"slugs":updateList}, providerId:updateProveiderId}));
    };

    const formSelectCheckbox = (val) => {
      let newArray = [];
      servicesCheckData.map((item) => {
        const item2 = val?.find((item1) => item1 === item.slug);
        if (item2) {
          newArray.push(item.slug);
        }
      });
      return newArray;
    };

  const tablistGroup = (item) => {
    setUpdateProveiderId(item.providerDisplayId);
    dispatch(fetchServicesListItems({practiceId: practiceId, providerId: item.providerDisplayId}));
  };

  const RenderFormCreatorForServices = () => {
    if (isServicesListItemsLoading) return null;
    return (
      <div className="technology-CG-Form">
        <CgFormCreator
          formClassName="technology-form"
          primaryButton="Save"
          onSubmitCallback={(val) => {
            const updateData =  formSelectCheckbox(val["ServiceCHeckbox"]);
            if(updateProveiderId !== ""){
            dispatch(updateServiceList({practiceId: practiceId,data:{"slugs":updateData}, providerId:updateProveiderId}));
            } else {
             setProviderIdCheck(true);   
            }
            setConfirmDeleteMap({});
            setOpenPopup(!openPopup);
          }}
          schema={ServicesSchema}
          onCancel={() => {
            setOpenPopup(false);
          }}
        />
      </div>
    );
  };

   const RenderServicePopUpModel = () =>{
      return(
        <PopupModal
          isOpen={openPopup}
          onClose={() => {
            setOpenPopup(!openPopup);
            setServiceList(serviceList);
          }}
          popupHeading="Services"
          customRender={RenderFormCreatorForServices}
          width={"70%"}
        />
      )
    }

  const RenderServicesSection = () => {
    if (isServicesListItemsLoading) return null;
    return(
      <div className="service-view-list">
          <ul>
            {serviceList?.map((item) => {
              return(
                <>
                  <li className="info-section" key={item.bundleCategoryId}>
                    <h5>{item.name}</h5>
                    <div className="deleteBtnwithConfirm">
                  {confirmDeleteMap[item.bundleCategoryId] && (
                    <button
                      type="button"
                      className="btn border-0 canceldelete"
                      onClick={() => toggleConfirmDelete(item.bundleCategoryId, false)}
                    >
                      CANCEL
                    </button>
                  )}
                  <button
                    type="button"
                    className={`btn ${
                      confirmDeleteMap[item.bundleCategoryId]
                        ? "deleteConfirmation"
                        : "border-0"
                    }`}
                    onClick={() => {
                      if (confirmDeleteMap[item.bundleCategoryId]) {
                        deleteAPiCall(item.bundleCategoryId);
                      } else {
                        toggleConfirmDelete(item.bundleCategoryId, true);
                      }
                    }}
                  >
                    {confirmDeleteMap[item.bundleCategoryId] ? "CONFIRM" : "DELETE"}
                  </button>
                </div>
                  </li>
                </>
              )
            })}
          </ul>
      </div>
    );
  };

  const RenderServicesError = () =>{
    if (!showError) return null;
    return(
      <div className="overlay-alert alert alert-danger" role="alert">
      {servicelistErrMsg}
      </div>
  )
  }

  const RenderProviderIDError = () =>{
    if (!providerIdCheck) return null;
    return(
      <div className="overlay-alert alert alert-danger" role="alert">
      Provider&apos;s not available
      </div>
  )
  }

  const RenderNoServicesInfo = () => {
    if (serviceList?.length > 0) return null;

    return (
      <div>
      </div>
    );
  };

  if (!servicesData?.length) {
    return null
  }
  
  return (
    <div className="practice-services">
      <div className="full-width-container display-flex">
        <div className="col-md-12">{RenderServiceTabContent()}</div>
      </div>
      <div className="full-width-container display-flex">
        <div className="col-md-12">
          <div className="service-section">
            <h3 className="section-header top-thirty overview">
              Services
              <a
                className="btn edit-button"
                onClick={() => {
                  setOpenPopup(!openPopup);
                }}
              >
                +Add
              </a>
            </h3>
          </div>
          <p className="header-note">Search results are based on your specialty and the commonly-performed procedures shown below.</p>
          {RenderProviderIDError()}          
          {RenderServicesError()}
          {RenderNoServicesInfo()}
          {RenderServicesSection()}
          {openPopup && RenderServicePopUpModel()}
        </div>
      </div>
    </div>
  );
};
export default Services;
